export default "__VITE_ASSET__c53f8329__"